import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { CurrencyProvider } from "./context/CurrencyContext";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import PropertiesPage from "./pages/PropertiesPage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import VisasPage from "./pages/VisasPage";
import VisaDetailPage from "./pages/VisaDetailPage";
import ContactPage from "./pages/ContactPage";
import CareersPage from "./pages/CareersPage";
import DestinationsPage from "./pages/DestinationsPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import PartnerLoginPage from "./pages/PartnerLoginPage";
import PartnerDashboard from "./pages/PartnerDashboard";
import PartnerPlansPage from "./pages/PartnerPlansPage";
import PartnerOnboardingPage from "./pages/PartnerOnboardingPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import "./App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <CurrencyProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#1A1D24',
              color: '#F8F9FA',
              border: '1px solid #2A2F3A',
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="properties" element={<PropertiesPage />} />
            <Route path="properties/:propertyId" element={<PropertyDetailPage />} />
            <Route path="visas" element={<VisasPage />} />
            <Route path="visa-programs" element={<VisasPage />} />
            <Route path="visas/:visaId" element={<VisaDetailPage />} />
            <Route path="destinations" element={<DestinationsPage />} />
            <Route path="destinations/:destinationId" element={<DestinationsPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="careers" element={<CareersPage />} />
          </Route>
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/partner" element={<PartnerLoginPage />} />
          <Route path="/partner/dashboard" element={<PartnerDashboard />} />
          <Route path="/partner/plans" element={<PartnerPlansPage />} />
          <Route path="/partner/onboard" element={<PartnerOnboardingPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
        </Routes>
      </BrowserRouter>
    </CurrencyProvider>
  );
}

export default App;
